/**
 * Strings for the earned-media scout. Every key starts with `ms.`. Spread
 * into both dictionaries in web/src/lib/i18n.ts; the `satisfies` below makes
 * a missing or extra Spanish key a type error here.
 */
export const mediaScoutEn = {
  "ms.title": "Media scout",
  "ms.subtitle":
    "Earned-media openings for Chris: hearings, community events, reporters on your issues, and the key dates on your own calendar.",
  "ms.banner":
    "Suggestions, not verified facts. Check the source before acting. Nothing here feeds the advisor.",
  "ms.suggestion": "Suggestion",
  "ms.runNow": "Search now",
  "ms.running": "Searching…",
  "ms.runResult": "{hooks} calendar dates · {fresh} new from the web",
  "ms.runSkippedLicense": "{hooks} calendar dates updated. The web search needs an active license.",
  "ms.runSkippedCredits": "{hooks} calendar dates updated. The web search needs AI credits.",
  "ms.lastRun": "Last search",
  "ms.never": "never",
  "ms.schedule": "Searches every morning at 6:30",
  "ms.lastRunFailed": "Last search failed",
  "ms.urgency.now": "Now",
  "ms.urgency.this_week": "This week",
  "ms.urgency.upcoming": "Upcoming",
  "ms.filter.all": "All",
  "ms.filter.urgency": "Filter by urgency",
  "ms.filter.kind": "Filter by type",
  "ms.filter.plank": "Filter by issue",
  "ms.filter.allPlanks": "All issues",
  "ms.view.open": "To do",
  "ms.view.done": "Done",
  "ms.kind.council_agenda": "Council agenda",
  "ms.kind.public_hearing": "Public hearing",
  "ms.kind.community_event": "Community event",
  "ms.kind.reporter_story": "Reporter story",
  "ms.kind.news_hook": "News hook",
  "ms.kind.finance_report": "Report day",
  "ms.kind.calendar_hook": "Key date",
  "ms.plank.PLANK-01-JOBS": "Jobs",
  "ms.plank.PLANK-02-BUDGET": "Budget",
  "ms.plank.PLANK-03-HOUSING": "Housing",
  "ms.plank.PLANK-04-PERMITS": "Permits",
  "ms.plank.PLANK-05-PLAZA": "Deck Plaza / I-10",
  "ms.plank.PLANK-06-DOWNTOWN": "Downtown",
  "ms.plank.PLANK-07-SAFETY": "Public safety",
  "ms.plank.PLANK-08-META": "Meta",
  "ms.plank.PLANK-09-SUNMETRO": "Sun Metro",
  "ms.plank.PLANK-10-SEGUNDO": "Segundo Barrio",
  "ms.plank.PLANK-11-ETHICS": "Ethics",
  "ms.plank.PLANK-12-UTILITIES": "Utility bills",
  "ms.angle": "Suggested angle",
  "ms.fromCalendar": "From your calendar",
  "ms.reporter": "Reporter: {name}",
  "ms.undated": "No date",
  "ms.rel.today": "Today",
  "ms.rel.tomorrow": "Tomorrow",
  "ms.rel.inDays": "In {n} days",
  "ms.rel.yesterday": "Yesterday",
  "ms.rel.daysAgo": "{n} days ago",
  "ms.action.calendar": "Add to calendar",
  "ms.action.task": "Create task",
  "ms.action.dismiss": "Dismiss",
  "ms.action.working": "Saving…",
  "ms.noDateHint": "No date yet: create a task instead.",
  "ms.done.added_to_calendar": "On the calendar",
  "ms.done.task_created": "Task created",
  "ms.openCalendar": "Open calendar",
  "ms.openTasks": "Open tasks",
  "ms.toast.calendar": "Added to the calendar.",
  "ms.toast.task": "Task created.",
  "ms.toast.dismiss": "Dismissed.",
  "ms.empty.title": "All clear for now",
  "ms.empty.body":
    "No open opportunities. The scout checks council agendas, community events, and local reporters every morning, and adds your calendar's key dates automatically.",
  "ms.empty.filtered": "Nothing matches these filters.",
  "ms.empty.clear": "Clear filters",
  "ms.empty.done": "Nothing handled yet. Opportunities you add or turn into tasks show up here.",
} as const;

export const mediaScoutEs = {
  "ms.title": "Radar de medios",
  "ms.subtitle":
    "Oportunidades de medios ganados para Chris: audiencias, eventos comunitarios, reporteros que cubren tus temas y las fechas clave de tu propio calendario.",
  "ms.banner":
    "Son sugerencias, no hechos verificados. Revisa la fuente antes de actuar. Nada de esto alimenta al asesor.",
  "ms.suggestion": "Sugerencia",
  "ms.runNow": "Buscar ahora",
  "ms.running": "Buscando…",
  "ms.runResult": "{hooks} fechas del calendario · {fresh} nuevas de la web",
  "ms.runSkippedLicense":
    "{hooks} fechas del calendario actualizadas. La búsqueda web requiere una licencia activa.",
  "ms.runSkippedCredits":
    "{hooks} fechas del calendario actualizadas. La búsqueda web requiere créditos de IA.",
  "ms.lastRun": "Última búsqueda",
  "ms.never": "nunca",
  "ms.schedule": "Busca cada mañana a las 6:30",
  "ms.lastRunFailed": "La última búsqueda falló",
  "ms.urgency.now": "Ahora",
  "ms.urgency.this_week": "Esta semana",
  "ms.urgency.upcoming": "Próximas",
  "ms.filter.all": "Todas",
  "ms.filter.urgency": "Filtrar por urgencia",
  "ms.filter.kind": "Filtrar por tipo",
  "ms.filter.plank": "Filtrar por tema",
  "ms.filter.allPlanks": "Todos los temas",
  "ms.view.open": "Pendientes",
  "ms.view.done": "Hechas",
  "ms.kind.council_agenda": "Agenda del Concejo",
  "ms.kind.public_hearing": "Audiencia pública",
  "ms.kind.community_event": "Evento comunitario",
  "ms.kind.reporter_story": "Nota de reportero",
  "ms.kind.news_hook": "Tema en noticias",
  "ms.kind.finance_report": "Día de informe",
  "ms.kind.calendar_hook": "Fecha clave",
  "ms.plank.PLANK-01-JOBS": "Empleos",
  "ms.plank.PLANK-02-BUDGET": "Presupuesto",
  "ms.plank.PLANK-03-HOUSING": "Vivienda",
  "ms.plank.PLANK-04-PERMITS": "Permisos",
  "ms.plank.PLANK-05-PLAZA": "Deck Plaza / I-10",
  "ms.plank.PLANK-06-DOWNTOWN": "Centro",
  "ms.plank.PLANK-07-SAFETY": "Seguridad",
  "ms.plank.PLANK-08-META": "Meta",
  "ms.plank.PLANK-09-SUNMETRO": "Sun Metro",
  "ms.plank.PLANK-10-SEGUNDO": "Segundo Barrio",
  "ms.plank.PLANK-11-ETHICS": "Ética",
  "ms.plank.PLANK-12-UTILITIES": "Recibos",
  "ms.angle": "Ángulo sugerido",
  "ms.fromCalendar": "De tu calendario",
  "ms.reporter": "Reportero/a: {name}",
  "ms.undated": "Sin fecha",
  "ms.rel.today": "Hoy",
  "ms.rel.tomorrow": "Mañana",
  "ms.rel.inDays": "En {n} días",
  "ms.rel.yesterday": "Ayer",
  "ms.rel.daysAgo": "Hace {n} días",
  "ms.action.calendar": "Agregar al calendario",
  "ms.action.task": "Crear tarea",
  "ms.action.dismiss": "Descartar",
  "ms.action.working": "Guardando…",
  "ms.noDateHint": "Aún sin fecha: crea una tarea.",
  "ms.done.added_to_calendar": "En el calendario",
  "ms.done.task_created": "Tarea creada",
  "ms.openCalendar": "Ver calendario",
  "ms.openTasks": "Ver tareas",
  "ms.toast.calendar": "Agregada al calendario.",
  "ms.toast.task": "Tarea creada.",
  "ms.toast.dismiss": "Descartada.",
  "ms.empty.title": "Todo al día por ahora",
  "ms.empty.body":
    "No hay oportunidades pendientes. El radar revisa cada mañana las agendas del Concejo, los eventos comunitarios y a los reporteros locales, y agrega solo las fechas clave de tu calendario.",
  "ms.empty.filtered": "Nada coincide con estos filtros.",
  "ms.empty.clear": "Quitar filtros",
  "ms.empty.done":
    "Aún no hay nada atendido. Lo que agregues al calendario o conviertas en tarea aparece aquí.",
} satisfies Record<keyof typeof mediaScoutEn, string>;
